module.exports = __webpack_public_path__ + "img/sensor_color.3dd14c71.svg";